import { useEffect, useState } from "react";
import Button from "../../../common/Button";
import CustomSelect from "../../../common/interactive/CustomSelect";
import PracticePatientStatusRepeaterOption from "./PracticePatientStatusRepeaterOption";

export default function PracticePatientStatusRepeater({classes, item, mainSelectAction, matchAction, filtersValues, workQ}) {
    const [groups, setGroups] = useState([{
        practice_id: null,
        practice_patient_status_id: null
    }])

    function addRepeaterItemHandler() {
        setGroups(prev => [...prev, {
            practice_id: null,
            practice_patient_status_id: null
        }])
    }

    useEffect(() => {
        if (filtersValues && filtersValues.practice_patient_status_filters && filtersValues.practice_patient_status_filters.length) {
            setGroups(filtersValues.practice_patient_status_filters)
        } else {
            setGroups([{
                practice_id: null,
                practice_patient_status_id: null
            }])
        }
    }, [filtersValues])

    if (workQ?.filter_conditions?.practice_patient_status_filters_filter_type === 1) {
        return null
    }

    return <div className={classes.practice_status_filter_section}>
        <div className={classes.practice_status_filter_title}>Practice Status Filter</div>
        <div className={classes.practice_status_filter_body}>
            <div className={classes.practice_status_match_column}>
                <CustomSelect
                    preSelectedValue={filtersValues?.practice_patient_status_filters_match || workQ?.filter_conditions?.practice_patient_status_filters_match || 'and'}
                    optionsData={[
                        { label: 'AND', value: 'and' },
                        { label: 'OR', value: 'or' },
                    ]}
                    label={'Match Between Practices'}
                    identifier={{type: 'practice_patient_status_filters_match'}}
                    action={matchAction}
                />
            </div>
            <div className={classes.practice_status_rows}>
                {groups && groups.map((groupRepeater, index) => (
                    <div key={index} className={classes.practice_status_repeater_item}>
                        <PracticePatientStatusRepeaterOption
                            classes={classes}
                            filterItem={groupRepeater}
                            itemIndex={index}
                            mainSelectAction={mainSelectAction}
                            itemData={item}
                            workQ={workQ}
                            hasRemove={index != groups.length - 1}
                        />

                        {index == groups.length - 1 ? <div className={classes.practice_status_action}>
                            <Button click={addRepeaterItemHandler}><i className="ti ti-plus"></i></Button>
                        </div> : <></>}
                    </div>
                ))}
            </div>
        </div>
    </div>
}
